import { digiAccActorType } from "../common/TextTypes";
import { IActorGuiModel, IActorPostGuiModel, IActorPutGuiModel } from "../model/IActorGuiModel";
import ActorService from "../service/ActorService";
import { IActorModel, IActorPostModel, IActorPutModel } from "../service/model/IActorModel";
import { BusinessLogicDefaultResult, BusinessLogicResult, PageBusinessLogicResult } from "./BusinessLogicResult";

export default class ActorBusinessLogic {

    public async getActors(
        organizationId: string,
        accountType: digiAccActorType,
        freeText?: string,
        page?: number,
        pageSize?: number,
    ): Promise<PageBusinessLogicResult<IActorGuiModel[]>> {


        const service = new ActorService();
        let result;
        if (accountType === "Customer") {
            result = await service.getCustomers(organizationId, page, pageSize, freeText);
        } else {
            result = await service.getSuppliers(organizationId, page, pageSize, freeText);
        }

        if (result.hasErrors) {

            return new PageBusinessLogicResult([], 0, 0, 0, result.errors);

        } else {
            let apiData: IActorModel[] = result.value;

            let data: IActorGuiModel[] = apiData.map(e => {
                return {
                    customerId: e.customerId ? e.customerId : undefined,
                    supplierId: e.supplierId ? e.supplierId : undefined,
                    name: e.name ? e.name : undefined,
                    bankAccount: e.bankAccount ? e.bankAccount : undefined,
                    businessNumber: e.businessNumber ? e.businessNumber : undefined,
                    addressLine1: e.addressLine1 ? e.addressLine1 : undefined,
                    addressLine2: e.addressLine2 ? e.addressLine2 : undefined,
                    isoCountryCode: e.isoCountryCode ? e.isoCountryCode : undefined,
                    postalCode: e.postalCode ? e.postalCode : undefined,
                    postArea: e.postArea ? e.postArea : undefined,
                    emailAddress: e.emailAddress ? e.emailAddress : undefined,
                    comment: e.comment ? e.comment : undefined,
                }
            });
            return new PageBusinessLogicResult(data, result.currentPage, result.totalPages, result.totalItems, result.errors);
        }
    };
    public async postActor(organizationId: string, type: digiAccActorType, data: IActorPostGuiModel): Promise<BusinessLogicDefaultResult> {

        const service = new ActorService();

        const newData: IActorPostModel = {
            name: data.name ? data.name : null,
            bankAccount: data.bankAccount ? data.bankAccount : null,
            businessNumber: data.businessNumber ? data.businessNumber : null,
            addressLine1: data.addressLine1 ? data.addressLine1 : null,
            addressLine2: data.addressLine2 ? data.addressLine2 : null,
            isoCountryCode: data.isoCountryCode ? data.isoCountryCode : null,
            postalCode: data.postalCode ? data.postalCode : null,
            postArea: data.postArea ? data.postArea : null,
            emailAddress: data.emailAddress ? data.emailAddress : null,
            comment: data.comment ? data.comment : null
        }

        const result = await service.postActor(organizationId, type, newData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }

    }

    public async putActor(organizationId: string, type: digiAccActorType, id: number, data: IActorPutGuiModel): Promise<BusinessLogicDefaultResult> {

        const service = new ActorService();

        const newData: IActorPutModel = {
            name: data.name?.value !== undefined ? { value: data.name.value } : { value: null },
            bankAccount: data.bankAccount?.value !== undefined ? { value: data.bankAccount.value } : { value: null },
            businessNumber: data.businessNumber?.value !== undefined ? { value: data.businessNumber.value } : { value: null },
            addressLine1: data.addressLine1?.value !== undefined ? { value: data.addressLine1.value } : { value: null },
            addressLine2: data.addressLine2?.value !== undefined ? { value: data.addressLine2.value } : { value: null },
            isoCountryCode: data.isoCountryCode?.value !== undefined ? { value: data.isoCountryCode.value } : { value: null },
            postalCode: data.postalCode?.value !== undefined ? { value: data.postalCode.value } : { value: null },
            postArea: data.postArea?.value !== undefined ? { value: data.postArea.value } : { value: null },
            emailAddress: data.emailAddress?.value !== undefined ? { value: data.emailAddress.value } : { value: null },
            comment: data.comment?.value !== undefined ? { value: data.comment.value } : { value: null },
        };


        const result = await service.putActor(organizationId, type, id, newData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }

    }
}